if(typeof lazySizes === 'undefined'){
	/*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var notFirst = !1,
    onSale = !1,
    soldOut = !1,
    priceVaries = !1,
    images = [],
    firstVariant = {},
    bcSfFilterSettings = {
        general: {
            limit: bcSfFilterConfig.custom.products_per_page,
            loadProductFirst: false
        }
    },
    bcSfFilterTemplate = {
        soldOutClass: "",
        soldOutClassAjax: "sold-out",
        saleClass: " on-sale",
        soldOutLabelHtml: "",
        saleLabelHtml: "<span class=\"sale bc-sf-filter-label\">" + bcSfFilterConfig.label_basic.sale + "</span>",
        tagLabelHtml: "<span class=\"tag bc-sf-filter-label {{labelTag}}\" >{{labelTag}}</span>",
        vendorHtml: "<p class=\"bc-sf-filter-product-item-vendor\">{{itemVendorLabel}}</p>",
      	productGridItemHtml: "<div boost-item='{{itemId}}' data-handle='{{itemHandle}}' class=\"bc-sf-filter-product-item bc-sf-filter-product-item-grid {{gridWidthClass}}{{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}\"><script class=\"bc-sf-filter-product-script\" data-id=\"bc-product-json-{{itemId}}\" type=\"application/json\">{{itemJson}}</script><div class=\"bc-sf-filter-product-item-inner\"><div class=\"bc-sf-filter-product-item-image\"><div data-flair-product-badge data-product-id=\"{{itemId}}\" data-layout=\"Overlay\"></div>{{itemWishlist}}<a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-image-link\">{{itemImages}}</a></div><div class=\"bc-sf-filter-product-item-label\"><span class=\"soldout soldout-hidden bc-sf-filter-label\" >" + bcSfFilterConfig.label_basic.sold_out + "</span>{{itemLabels}}{{itemTagLabels}}</div><div class=\"bc-sf-filter-product-bottom\">{{itemInstoreBadge}}<ul class=\"list-colors js-image-change\">{{itemColors}}</ul><!-- /.list-colors --><a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-title\">{{itemTitle}}</a>{{itemVendor}}{{itemPrice}}<span class=\"stamped-product-reviews-badge\" data-id=\"{{itemId}}\"></span><div class=\"showroom-actions\">{{showroomActions}}</div></div></div></div>",
        productListItemHtml: "<div boost-item='{{itemId}}' class=\"bc-sf-filter-product-item bc-sf-filter-product-item-list {{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}\"><div class=\"bc-sf-filter-product-item-list-col-1\"><div class=\"bc-sf-filter-product-item-image\"><div class=\"bc-sf-filter-product-item-label\">{{itemLabels}}{{itemTagLabels}}</div><a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-image-link\">{{itemImages}}</a></div></div><div class=\"bc-sf-filter-product-bottom\"><div class=\"bc-sf-filter-product-item-list-col-2\">{{itemInstoreBadge}}<a href=\"{{itemUrl}}\" class=\"bc-sf-filter-product-item-title\">{{itemTitle}}</a>{{itemVendor}}<p class=\"bc-sf-filter-des\">{{itemDescription}}</p></div><div class=\"bc-sf-filter-product-item-list-col-3\">{{itemPrice}}</div></div></div>",
        previousActiveHtml: "<li><a href=\"{{itemUrl}}\" rel=\"prev\"><i class=\"ico-arrow-left\"></i></a></li>",
        previousDisabledHtml: "<li class=\"disabled\"><span><i class=\"ico-arrow-left\"></i></span></li>",
        nextActiveHtml: "<li><a href=\"{{itemUrl}}\" rel=\"next\"><i class=\"ico-arrow-right\"></i></a></li>",
        nextDisabledHtml: "<li class=\"disabled\"><span><i class=\"ico-arrow-right\"></i></span></li>",
        pageItemHtml: "<li><a href=\"{{itemUrl}}\">{{itemTitle}}</a></li>",
        pageItemSelectedHtml: "<li><span class=\"active\">{{itemTitle}}</span></li>",
        pageItemRemainHtml: "<li><span>{{itemTitle}}</span></li>",
        paginateHtml: "<ul>{{previous}}{{pageItems}}{{next}}</ul>",
        sortingHtml: "<label>" + bcSfFilterConfig.label.sorting + "</label><select class=\"bc-sf-filter-filter-dropdown\">{{sortingItems}}</select>",
        showLimitHtml: "<label>" + bcSfFilterConfig.label.show_limit + "</label><select class=\"bc-sf-filter-filter-dropdown\">{{showLimitItems}}</select>",
        breadcrumbHtml: "<a href=\"/\">" + bcSfFilterConfig.label.breadcrumb_home + "</a> {{breadcrumbDivider}} {{breadcrumbItems}}",
        breadcrumbDivider: "<span class=\"divider\">/</span>",
        breadcrumbItemLink: "<a href=\"{{itemLink}}\">{{itemTitle}}</a>",
        breadcrumbItemSelected: "<span>{{itemTitle}}</span>"
    };

function prepareShopifyData(a) {
    soldOut = !a.available, onSale = a.compare_at_price_min > a.price_min, priceVaries = a.price_min != a.price_max, images = a.images_info;
    var b = a.variants[0];
    if (null !== getParam("variant") && "" != getParam("variant")) {
        var c = a.variants.filter(function(a) {
            return a.id == getParam("variant")
        });
        "undefined" != typeof c[0] && (b = c[0])
    } else
        for (var d = 0; d < a.variants.length; d++)
            if (a.variants[d].available) {
                b = a.variants[d];
                break
            } return a
}
BCSfFilter.prototype.buildExtrasProductListBadges = function(a, b) {
  // Builds our own badge list
  // Queues the sold out status update to as soon we end this function
  setTimeout(() => {
    $('.bc-sf-filter-product-item[data-handle]').each((i, o) => {
      var product = $(o);
      var handle = o.getAttribute('data-handle');
      $.get('/products/' + handle + '?view=availability', function (result) {
        var status = JSON.parse(result);

        // Checks if there was a valid server response (the request didn't fail for some reason)
        if (status && status.success) {
          // Sets availability
          if (status.available) {
            product.removeClass(bcSfFilterTemplate.soldOutClassAjax);
            product.find('.bc-sf-filter-label.soldout')
              .addClass('soldout-hidden')
              .addClass('hidden');
            product.find('.itemFlair')
              .removeClass('hidden');
          } else {
            product.addClass(bcSfFilterTemplate.soldOutClassAjax);
            product.find('.bc-sf-filter-label.soldout')
              .removeClass('soldout-hidden')
              .removeClass('hidden');
            product.find('.itemFlair')
              .addClass('hidden');
          }
        }
      });
    });
  }, 1);
}
BCSfFilter.prototype.buildProductGridItem = function(a) {
    var b = bcSfFilterTemplate.productGridItemHtml;
    a = prepareShopifyData(a);
    var c = soldOut ? bcSfFilterTemplate.soldOutClass : "",
        d = onSale ? bcSfFilterTemplate.saleClass : "";


  // Force image sizes to use a size similar to 700px width, because it uses a full size image by default
    let imagesAr = [];
    a.images.forEach(function(img) {
      let src = img.src;
      img.original_src = src;

      if( src.indexOf('_360x') < 0 ) {
        let ratio = img.height / img.width;
        img.height = ratio * 360;
        img.width = 360;

        let srcAr = [];
        let ext = '.jpg';
        if( src.indexOf('.jpg') > -1 ) {
          srcAr = src.split('.jpg');
        }
        else {
          srcAr = src.split('.png');
          ext = '.png';
        }

        if( srcAr.length > 0 ) {
          srcAr[0] = srcAr[0] + '_360x';
          img.src = srcAr[0] + ext + srcAr[1];
          img.src = img.src.replace('_360x_360x', '_360x');
        }
      }

      imagesAr.push(img);
    });
    a.images = imagesAr;

    let builtImages = buildImages(a);


    b = b.replace(/{{soldOutClass}}/g, c), b = b.replace(/{{saleClass}}/g, d), b = b.replace(/{{gridWidthClass}}/g, buildGridWidthClass(a)), b = b.replace(/{{itemLabels}}/g, buildLabels(a)), b = b.replace(/{{itemInstoreBadge}}/g, buildInstoreBadge(a)), b = b.replace(/{{itemTagLabels}}/g, buildTagLabels(a, !1)), b = b.replace(/{{itemImages}}/g, builtImages), b = b.replace(/{{itemPrice}}/g, buildPrice(a)), b = b.replace(/{{itemVendor}}/g, buildVendor(a));
    var e = bcSfFilterConfig.custom.active_image_swap ? "has-bc-swap-image" : "";
    b = b.replace(/{{itemActiveSwapClass}}/g, e);
    var f = this,
        g = {
            id: a.id,
            title: a.title,
            handle: a.handle,
            vendor: a.vendor,
            variants: a.variants,
            url: f.buildProductItemUrl(a),
            options_with_values: a.options_with_values,
            images: a.images,
            available: a.available,
            price_min: a.price_min,
            price_max: a.price_max,
            compare_at_price_min: a.compare_at_price_min,
            compare_at_price_max: a.compare_at_price_max
        };
    b = b.replace(/{{itemJson}}/g, JSON.stringify(g));
    var h = "<!-- include 'wishlist-button-collection' with '" + a.id + "' -->";
    b = b.replace(/{{itemWishlist}}/g, h);
    b = b.replace(/{{itemId}}/g, a.id);
    b = b.replace(/{{itemTitle}}/g, a.title);
    b = b.replace(/{{itemHandle}}/g, a.handle);
    b = b.replace(/{{itemVendorLabel}}/g, a.vendor);
    b = b.replace(/{{itemUrl}}/g, this.buildProductItemUrl(a));
    b = b.replace(/{{itemColors}}/g, buildColors(a));

    // Adds Showroom button
    b = b.replace(/{{showroomActions}}/g, window.buildShowroomProductActions ? window.buildShowroomProductActions(a) : '');
    
    // Returns built item
    return b;
}, BCSfFilter.prototype.buildProductListItem = function(a) {


  // Force image sizes to use a size similar to 700px width, because it uses a full size image by default
  let imagesAr = [];
  a.images.forEach(function(img) {
    let src = img.src;
    img.original_src = src;

    if( src.indexOf('_360x') < 0 ) {
      let ratio = img.height / img.width;
      img.height = ratio * 360;
      img.width = 360;

      let srcAr = [];
      let ext = '.jpg';
      if( src.indexOf('.jpg') > -1 ) {
        srcAr = src.split('.jpg');
      }
      else {
        srcAr = src.split('.png');
        ext = '.png';
      }

      if( srcAr.length > 0 ) {
        srcAr[0] = srcAr[0] + '_360x';
        img.src = srcAr[0] + ext + srcAr[1];
        img.src = img.src.replace('_360x_360x', '_360x');
      }
    }

    imagesAr.push(img);
  });
  a.images = imagesAr;
  let builtImages = buildImages(a);



    var b = a.images_info,
        c = !a.available,
        d = a.compare_at_price_min > a.price_min,
        e = a.price_min != a.price_max,
        f = a.variants[0];
    if (null !== getParam("variant") && "" != getParam("variant")) {
        var g = a.variants.filter(function(a) {
            return a.id == getParam("variant")
        });
        "undefined" != typeof g[0] && (f = g[0])
    } else
        for (var h = 0; h < a.variants.length; h++)
            if (a.variants[h].available) {
                f = a.variants[h];
                break
            } var j = bcSfFilterTemplate.productListItemHtml;
    a = prepareShopifyData(a);
    var k = c ? bcSfFilterTemplate.soldOutClass : "",
        l = d ? bcSfFilterTemplate.saleClass : "";
    j = j.replace(/{{soldOutClass}}/g, k), j = j.replace(/{{saleClass}}/g, l), j = j.replace(/{{itemLabels}}/g, buildLabels(a)), j = j.replace(/{{itemInstoreBadge}}/g, buildInstoreBadge(a)), j = j.replace(/{{itemTagLabels}}/g, buildTagLabels(a, !1)), j = j.replace(/{{itemImages}}/g, builtImages), j = j.replace(/{{itemVendor}}/g, buildVendor(a));
    var m = buildPrice(a, d, e);
    j = j.replace(/{{itemPrice}}/g, m);
    var n = jQ("<p>" + a.body_html + "</p>").text();
    n = 40 < n.split(" ").length ? n.split(" ").splice(0, 40).join(" ") + "..." : n.split(" ").splice(0, 40).join(" "), j = j.replace(/{{itemDescription}}/g, n);
    var o = bcSfFilterConfig.custom.active_image_swap ? "has-bc-swap-image" : "";
    return j = j.replace(/{{itemActiveSwapClass}}/g, o), j = j.replace(/{{itemTitle}}/g, a.title), j = j.replace(/{{itemVendorLabel}}/g, a.vendor), j = j.replace(/{{itemUrl}}/g, this.buildProductItemUrl(a)), j
};

/*
function buildColors(a) {
    for (var b = [], c = window.productColors, d = a.options_with_values, e = a.variants, f = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1], g = a.images_info, h = 0, k = 0; k < a.options_with_values.length; k++) "color" == a.options_with_values[k].name && (h = a.options_with_values[k].values.length);
    for (var k = 0; 3 > k; k++)
        if (void 0 !== d[k] && "color" === d[k].name)
            for (var m = 3 > h ? h : 3, n = [], o = 0; o < e.length; o++) {
                var p = [],
                    q = "option" + (k + 1);
                if (void 0 !== e[o]) {
                    var r = e[o][q].toLowerCase().replace(" ", "-").replace("/", "-").replace("\\", "-");
                    if (-1 == n.indexOf(r) && 3 > n.length) {
                        for (var s = 0; s < c.length; s++) c[s].hasOwnProperty(r) && (p.push(e[o].image, c[s][r], e[o].id, r), b.push(p));
                        n.push(r)
                    }
                }
            }
    var t = "",
        u = "class=\"current\"";
    notFirst && (u = "");
    for (var k = 0; k < b.length; k++) {
        if (0 != k && (u = ""), null !== b[k][0]) var v = "<li " + u + "><span data-image=\"" + b[k][0] + "\" style=\"background: " + b[k][1] + ";\" data-variant-id=\"" + b[k][2] + "\" data-name-handle=\"" + b[k][3] + "\"></span></li>";
        else var v = "<li " + u + "><span data-name-handle=\"" + b[k][3] + "\" style=\"background: " + b[k][1] + ";\"></span></li>";
        t += v
    }
    var w = 1 < h ? h + " Colors" : h + " Color";
    return t = t + "<li><p>" + w + "</p></li>", t
}
*/

/* WS v17 (31 Jul): color-chip swatches were rendering blank/invisible for
   many wedding-dress variants. Root cause confirmed live against
   window.productColors (150 entries, exact-match only): simple names like
   "Ivory" exist, but the many COMPOUND variant names actually used on
   products ("All Ivory", "Ivory/Blush", "Ivory Matte Satin",
   "Ivory/Sand/Ivory", "French Blue/Pewter Accent") have no exact entry, so
   the old single-pass exact match returned undefined and buildColors()
   emitted invalid CSS (background-color: undefined), leaving the chip
   blank. Some individual segments ("French Blue", "Pewter") don't exist
   under ANY name in the list at all, so segment-matching alone can't fully
   solve it either. Fix: try exact match first (original behavior,
   preserved), then try each "/"-separated segment (fixes "Ivory/Blush",
   "All Ivory" style prefixes), then strip common fabric/qualifier words and
   retry, and finally fall back to a neutral gray swatch instead of
   `undefined` so the chip always renders as a visible, clickable color
   swatch even when we truly have no documented hex for it. */
function getColorCode(name){
    if(name == 'Strom' || name == 'strom'){
      name = 'storm';
    }
    var allColors = window.productColors;
    var normalize = function(s){
        return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    };
    var lookupOwn = function(raw){
        var key = normalize(raw);
        if (!key) return undefined;
        for (var i = 0; i < allColors.length; i++) {
            if (normalize(allColors[i].name) === key) {
                return allColors[i][normalize(allColors[i].name)];
            }
        }
        return undefined;
    };
    /* WS v18 (31 Jul): Jimmy reported collection-card swatches not matching
       the SAME product's PDP swatches (e.g. Maggie Sottero Natalie: "All
       Ivory" / "Ivory over Blush" / "Ivory over Blush with Medium Nude
       Illusion" render differently, or blank, on the collection card vs.
       the PDP). Root cause: this page's own window.productColors (loaded
       from the collection template's own curated color blocks) simply
       doesn't define these names - but the PRODUCT's own template does.
       Every product template maintains its own separate color-block list,
       so gaps like this exist across the catalog. ws-color-master.js is a
       theme-wide union of every color block from every template
       (assets/ws-color-master.js has the full rationale). Checking it
       right alongside the page's own list - not after the fuzzy
       strip-qualifier-words fallback below - matters: "All Ivory" strips
       down to "Ivory" and would otherwise match this page's generic Ivory
       entry (a slightly different, less accurate off-white) before ever
       reaching the master list's exact "All Ivory" entry. Trying exact/
       segment matches against BOTH sources first gets the precise PDP
       value whenever it's documented anywhere in the theme; only names
       with no exact match anywhere fall through to the word-stripping
       heuristic and finally the neutral placeholder. */
    var lookupMaster = function(raw){
        if (!window.wsColorMaster) return undefined;
        var key = normalize(raw);
        if (!key) return undefined;
        var entry = window.wsColorMaster[key];
        return entry ? entry.value : undefined;
    };
    var lookupAny = function(raw){
        var v = lookupOwn(raw);
        if (v !== undefined) return v;
        return lookupMaster(raw);
    };
    var tryName = function(raw){
        var direct = lookupAny(raw);
        if (direct !== undefined) return direct;
        var parts = String(raw).split('/').map(function(p){ return p.trim(); }).filter(Boolean);
        if (parts.length > 1) {
            for (var i = 0; i < parts.length; i++) {
                var m = lookupAny(parts[i]);
                if (m !== undefined) return m;
            }
        }
        return undefined;
    };
    var found = tryName(name);
    if (found !== undefined) return found;
    var stripped = String(name).replace(/\b(all|matte|satin|stretched|mikado|accent|liner|lining|chiffon|crepe|tulle|fabric)\b/gi, ' ').replace(/\s+/g, ' ').trim();
    if (stripped && stripped.toLowerCase() !== String(name).toLowerCase()) {
        found = tryName(stripped);
        if (found !== undefined) return found;
    }

    // No documented color match anywhere in window.productColors or the
    // theme-wide ws-color-master list for this name or any of its segments
    // (e.g. names with no match under any vendor's template) — return a
    // neutral placeholder so the chip stays visible/clickable instead of
    // rendering with invalid CSS
    // ("background-color: undefined").
    return '#D8D3D0';
}

function buildColors(data) {
  	var currentImage = '';
    var filteredUrl = new URL(window.location.href);
    var colorParam = filteredUrl.searchParams.getAll("pf_opt_color");
    var swatchesHtml = '';
  	var collectionHandle = "";
  	if(bcSfFilterMainConfig.general.collection_handle.includes("color-")){
      collectionHandle = bcSfFilterMainConfig.general.collection_handle.replace("color-","").replace('-', ' ');
    }
    for (var k in data.options) {
        var option = data['options'][k];
        var optionHandle = bcsffilter.slugify(option);
        var optionIndex = k;

        var isColor = false;
        var downcasedOption = option.toLowerCase();
        if (downcasedOption.indexOf('color') > -1 || downcasedOption.indexOf('colour') > -1) {
            var values = '';
          	var indexOfColor = 0;
            if(colorParam.length > 0){
              for (var i = 0; i < data.variants.length; i++) {
                  if(colorParam[0] == data['variants'][i]['options'][optionIndex]){
                    indexOfColor = i;
                  }
              }
            }else{
              if(collectionHandle !== ""){
                for (var i = 0; i < data.variants.length; i++) {
                    if(collectionHandle == data['variants'][i]['options'][optionIndex].toLowerCase()){
                      indexOfColor = i;
                    }
                }
              }
            }

            if(data.variants.length > 3){
              if(indexOfColor >= 1 && indexOfColor < data.variants.length - 1){
                var distinctColorCount = 0;
                for (var i in data.variants) {
                    if (distinctColorCount >= 3) break;
                    var variant = data['variants'][i];

                    var value = variant['options'][optionIndex];
                    var wrappedValue = ',' + value + ',';
                    /* WS v19 (31 Jul): picking swatches by raw variant INDEX
                       (indexOfColor -1/0/+1) breaks whenever there's a
                       second option besides Color (e.g. Material) - adjacent
                       variant indices are usually the SAME color with a
                       different Material, so this could render up to 3
                       duplicate swatches for one color instead of 3 distinct
                       ones. Dedup by color value and stop once 3 distinct
                       colors are found instead. */
                    if(values.indexOf(wrappedValue) == -1){
                      values += wrappedValue;
                      distinctColorCount++;
                      var classCurrent = "";
                      var currentColorValue = data.variants[parseInt(indexOfColor)] ? data.variants[parseInt(indexOfColor)]['options'][optionIndex] : null;
                      if(value == currentColorValue){
                        classCurrent = "class='current'";
                      }
                      variant.image = fixImgSize(variant.image);

                      let colorCode = getColorCode(bcsffilter.slugify(value));

                      let colorCSSRule;
                      if(typeof colorCode !== "undefined"){
                        colorCSSRule = colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                      }else{
                        colorCSSRule = 'background-color';
                      }
                      swatchesHtml += '<li '+classCurrent+'>';
                      swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + '"></span>';
                      swatchesHtml += '</li>';
                    }
                }
              } else if(indexOfColor >= data.variants.length - 1) {
              	for (var i in data.variants) {
                    var variant = data['variants'][i];

                  variant.image = fixImgSize(variant.image);

                    var value = variant['options'][optionIndex];
                    var wrappedValue = ',' + value + ',';
                    if(i == parseInt(indexOfColor) || i == parseInt(indexOfColor) - 1 || i == parseInt(indexOfColor) - 2){
                      var classCurrent = "";
                      if(i == parseInt(indexOfColor)){
                        classCurrent = "class='current'";
                      }
                      if (values.indexOf(wrappedValue) == -1) {
                      let colorCode = getColorCode(bcsffilter.slugify(value));
                      let colorCSSRule = typeof colorCode != "undefined" && colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                      if (values.indexOf(wrappedValue) == -1) {
                              swatchesHtml += '<li '+classCurrent+'>';
                              swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + '"></span>';
                              swatchesHtml += '</li>';
                          values += wrappedValue;
                      }
                    }
                  }
                }
              }else{
                var distinctColorCount = 0;
                for (var i in data.variants) {
                    if (distinctColorCount >= 3) break;
                    var variant = data['variants'][i];

                    var value = variant['options'][optionIndex];
                    var wrappedValue = ',' + value + ',';
                    /* WS v19 (31 Jul): this default (no filter active) case
                       used to just take the first 3 VARIANTS by array index
                       (i == 0/1/2). Shopify orders variants by option1 then
                       option2, so when Color is option1 and a second option
                       (e.g. Material) exists, the first several variants are
                       often all the SAME color - Jimmy's Maggie Sottero
                       Natalie example has 4 Material variants per color, so
                       indices 0/1/2 were all "All Ivory", rendering 3
                       identical swatches instead of the product's 3 actual
                       colors. Dedup by color value instead. */
                    if(values.indexOf(wrappedValue) == -1){
                      values += wrappedValue;
                      distinctColorCount++;
                      var classCurrent = "";
                      if(distinctColorCount == 1){
                        classCurrent = "class='current'";
                      }
                      variant.image = fixImgSize(variant.image);
                      let colorCode = getColorCode(bcsffilter.slugify(value));
                      let colorCSSRule;
                      if(typeof colorCode !== "undefined"){
                        colorCSSRule = colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                      }else{
                        colorCSSRule = 'background-color';
                      }
                      swatchesHtml += '<li '+classCurrent+'>';
                      swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + ';"></span>';
                      swatchesHtml += '</li>';
                    }
                }
              }
            }else{
              for (var i in data.variants) {
                var variant = data['variants'][i];
                var value = variant['options'][optionIndex];
                var wrappedValue = ',' + value + ',';
                var classCurrent = "";
                if(i == parseInt(indexOfColor)){
                  classCurrent = "class='current'";
                }
                variant.image = fixImgSize(variant.image);
                let colorCode = getColorCode(bcsffilter.slugify(value));
                let colorCSSRule;
                if(typeof colorCode !== "undefined"){
                	colorCSSRule = colorCode.indexOf('gradient') > -1 ? 'background-image' : 'background-color';
                }else{
                	colorCSSRule = 'background-color';
                }
                swatchesHtml += '<li '+classCurrent+'>';
                swatchesHtml += '<span title="' + value + '" data-variant-id="'+variant.id+'" data-image="'+variant.image+'" data-name-handle="'+ value +'" data-option-title="' + value + '" style="' + colorCSSRule + ': ' + colorCode + '"></span>';
                swatchesHtml += '</li>';
              }
            }

            /* WS v19 (31 Jul): data.variants.length counts every variant
               (Color x Material/etc combinations), not distinct colors -
               Maggie Sottero Natalie has 3 colors x 4 materials = 12
               variants, so this showed "12 Colors" instead of "3 Colors".
               Use the color option's own values list (the true
               distinct-color count) when available, falling back to the
               old variant-count behavior only if that data is missing. */
            let distinctColorTotal = (data.options_with_values && data.options_with_values[k] && data.options_with_values[k].values) ? data.options_with_values[k].values.length : data.variants.length;
            let totalColors = data.product_type != 'Sample Dress' ? distinctColorTotal : data.variants.filter((variant) => variant.inventory_quantity > 0).length;
            let totalColorsText = data.product_type != 'Sample Dress' ? `${totalColors} Color${totalColors > 1 ? 's' : ''}` : 'Loading...';
            swatchesHtml += `<li><p>${totalColorsText}</p></li>`;
        }
    }
    return swatchesHtml;
}

function fixImgSize(src) {
  if(src === null) return src;
  let srcAr = [];
  let ext = '.jpg';
  let newSrc = src;
  if( src.indexOf('_360x') < 0 ) {
    if( src.indexOf('.jpg') > -1 ) {
      srcAr = src.split('.jpg');
    }
    else {
      srcAr = src.split('.png');
      ext = '.png';
    }
    if( srcAr.length > 0 ) {
      srcAr[0] = srcAr[0] + '_360x';
      newSrc = srcAr[0] + ext + srcAr[1];
    }
  }
  newSrc = newSrc.replace('_360x_360x', '_360x');
  return newSrc;
}

function buildGridWidthClass() {
    var a = "";
    switch (bcSfFilterConfig.custom.products_per_row) {
        case 2:
            a = "bc-sf-filter-grid-width-2";
            break;
        case 3:
            a = "bc-sf-filter-grid-width-3";
            break;
        case 5:
            a = "bc-sf-filter-grid-width-5";
            break;
        default:
            a = "bc-sf-filter-grid-width-4";
    }
    switch (bcSfFilterConfig.custom.products_per_row_mobile) {
        case 1:
            a += " bc-sf-filter-grid-width-mb-1";
            break;
        case 3:
            a += " bc-sf-filter-grid-width-mb-3";
            break;
        default:
            a += " bc-sf-filter-grid-width-mb-2";
    }
    return a
}

function getVariantImageByColor(variants, color){
  // Let's first try and find the proper variant
  const colorMatchingVariants = variants.filter(
    (variant) => (variant.option_color || '').toLowerCase() === color.toLowerCase()
  );

  // This is our resulting variant, it will be either the exactly matched variant from above, or the first variant in the set
  const variant = [
    ...colorMatchingVariants,
    ...variants,
  ][0];

  return variant 
    ? variant.image
    : null;
}

function buildImages(a) {
  	var filteredUrl = new URL(window.location.href);
    var colorParam = filteredUrl.searchParams.getAll("pf_opt_color");
  	var currentImage = "";
  	var collectionHandle = '';
    if(bcSfFilterMainConfig.general.collection_handle.includes("color-") && !bcSfFilterMainConfig.general.collection_handle.includes("swatches")){
      collectionHandle = bcSfFilterMainConfig.general.collection_handle.replace("color-","").replace('-', ' ');
    }
    /* WS v18 (31 Jul): removed a fallback that used to set collectionHandle
       to the raw URL slug ("wedding-dresses", "bridesmaid-dresses", etc.)
       for ANY collection page, not just genuine "shop by color" pages
       (color- prefixed handles, handled above). That fed straight into
       getVariantImageByColor(variants, collectionHandle) below, which -
       confirmed by reading it - falls back to variants[0]'s image when the
       "color" doesn't match anything (a normal collection slug never
       matches a real color name). variants[0].image is effectively always
       the same photo as the card's main image, so currentImage ended up
       non-null on every ordinary collection page, which skipped the
       correct images[1]-based branch further down and rendered the exact
       same photo for both the main and hover-flip images. Confirmed live:
       every sampled card on /collections/wedding-dresses had identical
       main/flip src even though the products' own image arrays have
       distinct photos (Kennedy Blue's equivalent cards correctly show a
       front/back pair). No current WS collection handle relies on this
       fallback - only the color- prefixed convention above is real "shop
       by color" behavior - so removing it restores the intended
       images[1] flip photo on every normal collection grid. */

    if (collectionHandle.includes('plus')) {
      // This is necessary so that the code below handles variant selection on plus size collections
      currentImage = null;
    } else if (colorParam.length > 0){
      // Selects by color query
      currentImage = getVariantImageByColor(a.variants, colorParam[colorParam.length - 1]);
    } else if (collectionHandle !== "") {
      // Selects by collection (Shop by Color)
    	currentImage = getVariantImageByColor(a.variants, collectionHandle);
    }

    var b = "",
        c = "",
        d = a.variants[0].image,
        e = window.location.href,
        f = e.split("&pf_"),
        g = !1,
        h = "none",
        j = "";
  var aspect_ratio , src , dataSrc , dataSrcSet , dataSizes , srcSet;

  if(images.length === 0){
  	aspect_ratio;
  	src = bcSfFilterConfig.general.no_image_url;
    dataSrc = bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url, "50x");
    dataSrcSet = bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url , '100x') + ' 100w, ' + bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url , '400x') + ' 400w,   ' +bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url , '500x') + ' 500w' ;
  	dataSizes = "auto";
  	srcSet = dataSrcSet;
    b += '<img src="'+ src +'" data-src="' + dataSrc + '" ';
    b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
    b += " class=\"transition--blur-up bc-sf-filter-product-item-main-image product-item__image-main lazyload\"  data-variant-id=\"" + h + "\" data-sizes=\"auto\" />"
    if(bcSfFilterConfig.custom.active_image_swap) {
          if(images.length > 1){
            var src= bcsffilter.optimizeImage(bcSfFilterConfig.general.no_image_url, "50x");
            dataSrc = bcsffilter.optimizeImage(src, '360x');
            dataSrcSet = bcsffilter.optimizeImage(src , '100x') + ' 100w, ' + bcsffilter.optimizeImage(src , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(src , '400x') + ' 400w' ;
            dataSizes = "auto";
            var srcSet = dataSrcSet;
          }
          	b +='<img src="'+ src +'" data-src="' + dataSrc + '" ';
            b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
            b += " class=\"transition--blur-up  bc-sf-filter-product-item-flip-image product-item__image-main lazyload\" data-sizes=\"auto\" />"
      }
    return b
  }else if (images.length > 0) {
    if(currentImage !== "" && typeof currentImage !== "undefined" && currentImage != null ){
      aspect_ratio = images[0]['width'] / images[0]['height'];
      //src= bcsffilter.optimizeImage(currentImage, "50x");
      src= currentImage;
      //dataSrc = bcsffilter.optimizeImage(currentImage, '900x');
      dataSrc = currentImage;
      dataSrcSet = bcsffilter.optimizeImage(currentImage , '100x') + ' 100w, ' + bcsffilter.optimizeImage(currentImage , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(currentImage , '400x') + ' 400w' ;
      dataSizes = "auto";
      srcSet = dataSrcSet;
      b += '<img src="'+ src +'" data-src="' + dataSrc + '" ';
      b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
      b += " class=\"transition--blur-up bc-sf-filter-product-item-main-image product-item__image-main lazyload\"  data-variant-id=\"" + h + "\" data-sizes=\"auto\" />"
      if(bcSfFilterConfig.custom.active_image_swap) {
          if(images.length > 1){
            //src= bcsffilter.optimizeImage(currentImage, "50x");
            src= currentImage;
            //dataSrc = bcsffilter.optimizeImage(currentImage, '900x');
            dataSrc = currentImage;
            dataSrcSet = bcsffilter.optimizeImage(currentImage , '100x') + ' 100w, ' + bcsffilter.optimizeImage(currentImage , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(currentImage , '400x') + ' 400w' ;
            dataSizes = "auto";
            var srcSet = dataSrcSet;
          }
          	b +='<img src="'+ src +'" data-src="' + dataSrc + '" ';
            b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="auto" srcset="'+srcSet+'" ';
            b += " class=\"transition--blur-up  bc-sf-filter-product-item-flip-image product-item__image-main lazyload\" data-sizes=\"auto\" />"
      }
      return b
    }else{
      let workingImage = images[0];

      if(collectionHandle.includes('plus')) {
        for(let i=0; i<images.length; i++) {
          if(images[i].alt != null && images[i].alt.includes('**plus**')) {
            workingImage = images[i];
            break;
          }
        }
      }

    	aspect_ratio = workingImage['width'] / workingImage['height'];
        //src= bcsffilter.optimizeImage(workingImage.src, "50x");
        src= workingImage.src;
        //dataSrc = bcsffilter.optimizeImage(workingImage.src, '900x');
        dataSrc = workingImage.src;
        dataSrcSet = bcsffilter.optimizeImage(workingImage.original_src , '100x') + ' 100w, ' + bcsffilter.optimizeImage(workingImage.original_src , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(workingImage.original_src , '400x') + ' 400w' ;
        dataSizes = "auto";
        srcSet = dataSrcSet;
      	b += '<img src="'+ src +'" data-src="' + dataSrc + '" ';
        b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="360w" srcset="'+srcSet+'" ';
        b += " class=\"transition--blur-up bc-sf-filter-product-item-main-image product-item__image-main lazyload\"  data-variant-id=\"" + h + "\" data-sizes=\"auto\" />"
        if(bcSfFilterConfig.custom.active_image_swap) {
          if(images.length > 1){
            //src= bcsffilter.optimizeImage(workingImage.src, "50x");
            src= images[1].src;
            //dataSrc = bcsffilter.optimizeImage(workingImage.src, '900x');
            dataSrc = images[1].src;
            var dataSrcSet = bcsffilter.optimizeImage(images[1].original_src , '100x') + ' 100w, ' + bcsffilter.optimizeImage(images[1].original_src , '300x') + ' 300w,   ' +bcsffilter.optimizeImage(images[1].original_src , '400x') + ' 400w' ;
            var dataAspectRatio = aspect_ratio;
            var dataSizes = "auto";
            var srcSet = dataSrcSet;
          }
          	b +='<img src="'+ src +'" data-src="' + dataSrc + '" ';
            b += 'data-srcset="' + dataSrcSet + '" data-aspectratio="'+ aspect_ratio +'" data-sizes="360w" srcset="'+srcSet+'" ';
            b += " class=\"transition--blur-up  bc-sf-filter-product-item-flip-image product-item__image-main lazyload\" data-sizes=\"auto\" />"
          }
   		return b
    }
 }
}

function buildVendor() {
    var a = "";
    return bcSfFilterConfig.custom.show_vendor && (a = bcSfFilterTemplate.vendorHtml), a
}

/* WS v20 (31 Jul): Jimmy wants an optional $500-increment price range in
   place of the plain "Contact Us For Pricing" text, toggled theme-wide via
   Theme Settings > Products > Contact Us For Pricing Products. Rounds DOWN
   to the nearest $500 for the low end (e.g. a real $1,959 price becomes
   "$1,500 - $1,999", matching Jimmy's reference), and includes a small "?"
   info icon with a tooltip explaining why the exact price isn't shown -
   he asked for this to sit right next to the range so it's clear this
   isn't the final price. a.price_min arrives here already in cents
   (bcsffilter.formatMoney expects cents, same as the branch below). */
/* WS v21 (31 Jul): whole-dollar formatter for the range - Jimmy: "take off
   the .00". bcsffilter.formatMoney() always follows the shop's money
   format, which includes cents (matches every other price on the site,
   correctly), but the bucketed range is always a round dollar amount by
   construction, so cents are pure noise here. Kept separate from
   formatMoney() rather than changing it, since every OTHER price on the
   site should keep its normal $X,XXX.XX formatting. */
function formatWholeDollar(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
}

function buildContactPriceRangeHtml(priceMinCents) {
    var bucketFloor = Math.floor(priceMinCents / 50000) * 50000;
    var bucketCeil = bucketFloor + 49900;
    var tooltipText = "Some designers don&#39;t allow us to publish exact pricing online. Contact us or book an appointment for exact pricing on this dress.";
    return "<p class=\"bc-sf-filter-product-item-price starting-price ws-price-range\">"
      + "<span class=\"ws-price-range-value\">" + formatWholeDollar(bucketFloor) + " - " + formatWholeDollar(bucketCeil) + "</span>"
      + "<span class=\"ws-price-range-info\" tabindex=\"0\">"
      + "<span class=\"ws-price-range-icon\" aria-hidden=\"true\">?</span>"
      + "<span class=\"ws-price-range-tooltip\">" + tooltipText + "</span>"
      + "</span>"
      + "</p>";
}

function buildPrice(a) {
    var b = "";
    if(typeof a.tags !== 'undefined' && a.tags.length > 0 && a.tags.includes('hidetag')) {
      if (bcSfFilterMainConfig.general.show_price_range_for_contact_products) {
        return buildContactPriceRangeHtml(a.price_min);
      }
      return "<p class='product__contact'>Contact Us For Pricing</p>";
    }
    let klass = a.variants.length == 1 ? 'hide-starting-price' : '';
    return bcSfFilterConfig.custom.show_price && (b = "<p class=\"bc-sf-filter-product-item-price starting-price\">", onSale ? (b += "<s>" + bcsffilter.formatMoney(a.compare_at_price_min) + "</s> ", b += "<span class=\"bc-sf-filter-product-item-sale-price\"><span class=\"starting-at "+klass+"\">Starting At</span>" + bcsffilter.formatMoney(a.price_min) + "</span>") : (priceVaries && (b += bcSfFilterConfig.label_basic.from + " "), b += "<span class=\"bc-sf-filter-product-item-regular-price starting-price\"><span class=\"starting-at "+klass+"\">Starting At</span>" + bcsffilter.formatMoney(a.price_min) + "</span>"), b += "</p>"), b
}

function buildLabels(p) {
    var a = "";
    bcSfFilterConfig.custom.show_sold_out_label && soldOut && (a = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, ""));
    var b = "";
    bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut && (b = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, ""));
    /* WS: the in-store badge used to live here (inside the absolute-positioned
       .bc-sf-filter-product-item-label overlay, over the product photo). Per
       Jimmy's feedback (29 Jul) it was distracting on the gown image, so it's
       been moved out of this overlay entirely — see buildInstoreBadge() below,
       rendered in-flow under the image via the {{itemInstoreBadge}} placeholder.
       Sold Out / Sale intentionally stay here as photo overlays (kept as-is
       per Jimmy's explicit call — standard, conversion-tested pattern). */
    return a + b;
}

/* WS: Try On In-Store badge (positive-only, keyed off the Boost availability
   tag). Rendered in-flow below the product image via {{itemInstoreBadge}},
   NOT inside the absolute-positioned label overlay — so no bc-sf-filter-label
   base class needed here. */
function buildInstoreBadge(p) {
    if (p && p.tags && p.tags.indexOf("Available in Store: In Stock") !== -1) {
        return "<span class=\"ws-instore-badge\">Try On In-Store</span>";
    }
    return "";
}

/* WS: collection toolbar product count + title row (30 Jul, v14). Mirrors
   Kennedy Blue's title-row pattern — wraps the H1 with a count span so
   shoppers see e.g. "All Wedding Dresses  677 Products" instead of a bare
   title. `total` is the same total_product value Boost's own pagination
   builder uses, so the count always reflects the current filtered result
   set. Called from buildPagination() below (before its early-return for
   single-page results, so the count still updates even on small result
   sets that don't need pagination controls). */
function buildWsTitleRow(total) {
    var $title = jQ(".bc-sf-filter-default-toolbar-inner .section__title").first();
    if ($title.length === 0) return;
    if (!$title.parent().hasClass("ws-title-row")) {
        $title.wrap('<div class="ws-title-row"></div>');
    }
    var $count = jQ("#bc-sf-filter-total-product");
    if ($count.length === 0) {
        $count = jQ('<span id="bc-sf-filter-total-product"></span>');
        $title.after($count);
    }
    var n = parseInt(total, 10) || 0;
    var label = n === 1 ? "Product" : "Products";
    $count.html(n + "<span> " + label + "</span>");
}

/* WS: mobile Filter/Sort action row (30 Jul, v14). Boost renders
   #bc-sf-filter-tree-mobile (the "Refine By" drawer trigger) as a sibling
   of the toolbar, not inside it — so on Kennedy Blue's site it's moved via
   JS into a shared row next to the sort dropdown, then styled as a matched
   branded button pair, visible only under the mobile breakpoint (CSS in
   ws-brand.css hides it at desktop widths). Mirrors that same approach here.
   Idempotent — checks for the wrapper before re-creating it, safe to call
   on every toolbar rebuild. */
function buildWsMobileActions() {
    if (jQ(".ws-mobile-actions").length > 0) return;
    var $toolbarInner = jQ(".bc-sf-filter-default-toolbar-inner");
    var $tree = jQ("#bc-sf-filter-tree-mobile");
    var $sortItem = jQ("#bc-sf-filter-top-sorting");
    if ($toolbarInner.length === 0 || $tree.length === 0 || $sortItem.length === 0) return;
    var $wrap = jQ('<div class="ws-mobile-actions"></div>');
    $toolbarInner.append($wrap);
    $wrap.append($tree);
    $wrap.append($sortItem);
}

/* WS: sort-dropdown cleanup (30 Jul, v14). Boost's getSortingList() (stock,
   bc-sf-filter-lib.js) hands back a plain {value: label} object built from
   its admin-configured customSortingList — live confirmed it returns both
   "manual" => "Featured" and "best-selling" => "Best Selling" as separate
   options. Jimmy: "Featured also needs to be 'best selling' and the current
   best selling needs to go away." Since this is a plain object we already
   receive in our own buildFilterSorting/buildDefaultElements overrides
   (both below), we can relabel + drop the entry here in theme JS — no
   Boost app-admin change needed. Applied as a shared helper so both
   sorting-render code paths stay in sync. */
function applyWsSortingLabels(list) {
    if (!list) return list;
    if (Object.prototype.hasOwnProperty.call(list, "manual")) {
        list.manual = "Best Selling";
    }
    if (Object.prototype.hasOwnProperty.call(list, "best-selling")) {
        delete list["best-selling"];
    }
    return list;
}

function buildTagLabels(a, b) {
    if (b) {
        var c = "";
        if (a.tags)
            for (var d, e = 0; e < a.tags.length; e++)
                if (d = a.tags[e], -1 !== d.indexOf("pfs:label")) {
                    var f = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, d.split("pfs:label-")[1]);
                    c += f
                }
    } else {
        var c = "";
        if (a.tags)
            for (var e = a.tags.length - 1; 0 <= e; e--)
                if (d = a.tags[e], -1 !== d.indexOf("pfs:label")) {
                    var f = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, d.split("pfs:label-")[1]);
                    c += f;
                    break
                }
    }
    return c
}
BCSfFilter.prototype.buildPagination = function(a) {
    buildWsTitleRow(a);
    var b = parseInt(this.queryParams.page),
        c = Math.ceil(a / this.queryParams.limit);
    if (1 == c) return jQ(this.selector.pagination).html(""), !1;
    if ("default" == this.getSettingValue("general.paginationType")) {
        var d = bcSfFilterTemplate.paginateHtml,
            e = 1 < b ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        e = e.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", b, b - 1)), d = d.replace(/{{previous}}/g, e);
        var f = b < c ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        f = f.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", b, b + 1)), d = d.replace(/{{next}}/g, f);
        for (var g = [], h = b - 1; h > b - 3 && 0 < h; h--) g.unshift(h);
        0 < b - 4 && g.unshift("..."), 0 <= b - 4 && g.unshift(1), g.push(b);
        for (var i = [], j = b + 1; j < b + 3 && j <= c; j++) i.push(j);
        b + 3 < c && i.push("..."), b + 3 <= c && i.push(c);
        for (var k = "", l = g.concat(i), m = 0; m < l.length; m++) k += "..." == l[m] ? bcSfFilterTemplate.pageItemRemainHtml : l[m] == b ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, k = k.replace(/{{itemTitle}}/g, l[m]), k = k.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", b, l[m]));
        d = d.replace(/{{pageItems}}/g, k), jQ(this.selector.pagination).html(d)
    }
}, BCSfFilter.prototype.buildFilterSorting = function() {
    /* WS v16 (31 Jul): Boost's "Mobile Filter Style" admin setting
       (general.filterTreeMobileStyle) is blank on this shop, confirmed live
       via bcsffilter.mobileStyle === "". With it blank, Boost's own click
       handler (buildFilterTreeMobileButtonEvent, stock bc-sf-filter-lib.js)
       falls back to a bare jQuery slideToggle of the DESKTOP #bc-sf-filter-tree
       instead of building a real mobile drawer — which is why tapping
       Filters on mobile did nothing useful. Kennedy Blue's own live site has
       this same setting set to "style2" (confirmed live), and the CSS for
       that mode already ships in this theme's bc-sf-filter.scss.liquid
       (.bc-sf-filter-tree-mobile-style2, #bc-sf-filter-mobile-toolbar, etc.)
       — it's just never been triggered. mobileStyle is read fresh off the
       instance on every click/build (not cached at bind time), so forcing
       it here on every toolbar rebuild is enough to make Boost's existing,
       fully-styled style2 drawer take over. This is a per-shop Boost admin
       setting, not a hardcoded theme value — the "correct" long-term fix is
       still to set it in Boost's app admin, but forcing it here gets it
       working immediately without needing that admin change. */
    this.mobileStyle = "style2";
    buildWsMobileActions();
    if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
        jQ(this.selector.topSorting).html("");
        var a = applyWsSortingLabels(this.getSortingList());
        if (a) {
            var b = "";
            for (var c in a) b += "<option value=\"" + c + "\">" + a[c] + "</option>";
            var d = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, b);
            jQ(this.selector.topSorting).html(d), jQ(this.selector.topSorting + " select").val(this.queryParams.sort)
        }
    }
}, BCSfFilter.prototype.buildFilterDisplayType = function() {
    jQ(".bc-sf-filter-product-item-inner").each(function() {
        var a = jQ(this),
            b = a.find("a"),
            c = a.find(".bc-sf-filter-product-item-main-image").data("variant-id");
        "none" != c && b.attr("href", `${b.attr("href").split("?variant=")[0]}?variant=${c}`)
    });
    var a = "<span>" + bcSfFilterConfig.label.toolbar_viewas + "</span>";
    a += "<a href=\"" + this.buildToolbarLink("display", "list", "grid") + "\" title=\"Grid view\" class=\"bc-sf-filter-display-item bc-sf-filter-display-grid\" data-view=\"grid\"><span class=\"icon-fallback-text\"><i class=\"fa fa-th\" aria-hidden=\"true\"></i><span class=\"fallback-text\">Grid view</span></span></a>", a += "<a href=\"" + this.buildToolbarLink("display", "grid", "list") + "\" title=\"List view\" class=\"bc-sf-filter-display-item bc-sf-filter-display-list\" data-view=\"list\"><span class=\"icon-fallback-text\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i><span class=\"fallback-text\">List view</span></span></a>";
    var b = jQ(this.getSelector("topDisplayType")),
        c = jQ(this.getSelector("products"));
    b.html(a), b.find(".bc-sf-filter-display-item").removeClass("active"), "list" == this.queryParams.display ? (b.find(".bc-sf-filter-display-list").addClass("active"), c.removeClass("bc-sf-filter-grid-view-items").addClass("bc-sf-filter-list-view-items")) : "grid" == this.queryParams.display && (b.find(".bc-sf-filter-display-grid").addClass("active"), c.removeClass("bc-sf-filter-list-view-items").addClass("bc-sf-filter-grid-view-items"))
}, BCSfFilter.prototype.buildDisplayTypeEvent = function() {
    var a = this,
        b = jQ(this.getSelector("topDisplayType")),
        c = jQ(this.getSelector("products"));
    jQ(this.getSelector("topDisplayType") + " a").click(function(d) {
        d.preventDefault(), a.internalClick = !0, jQ(this).parent().children().removeClass("active"), jQ(this).addClass("active"), "list" == a.queryParams.display ? (b.find(".bc-sf-filter-display-list").addClass("active"), c.removeClass("bc-sf-filter-grid-view-items").addClass("bc-sf-filter-list-view-items")) : "grid" == a.queryParams.display && (b.find(".bc-sf-filter-display-grid").addClass("active"), c.removeClass("bc-sf-filter-list-view-items").addClass("bc-sf-filter-grid-view-items"));
        var e = jQ(this).attr("href");
        a.onChangeData(e, "display")
    })
}, BCSfFilter.prototype.buildFilterShowLimit = function() {
    if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty("showLimitHtml")) {
        jQ(this.selector.topShowLimit).html("");
        var a = this.getSettingValue("general.showLimitList");
        if ("" != a) {
            for (var b = "", c = a.split(","), d = 0; d < c.length; d++) b += "<option value=\"" + c[d].trim() + "\">" + c[d].trim() + "</option>";
            var e = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, b);
            jQ(this.selector.topShowLimit).html(e), jQ(this.selector.topShowLimit + " select").val(this.queryParams.limit)
        }
    }
}, BCSfFilter.prototype.buildBreadcrumb = function(a) {
    if (bcSfFilterTemplate.hasOwnProperty("breadcrumbHtml")) {
        var b = "";
        if ("undefined" != typeof a && a.hasOwnProperty("collection")) {
            var c = a.collection;
            "undefined" != typeof this.collectionTags && null !== this.collectionTags ? (b += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, "/collections/" + c.handle).replace(/{{itemTitle}}/g, c.title), b += " {{breadcrumbDivider}} ", b += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0])) : b += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, c.title)
        } else b += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue("label.defaultCollectionHeader"));
        var d = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, b);
        d = d.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider), jQ(this.selector.breadcrumb).html(d)
    }
};

function matchHeightImage() {
    jQ(".bc-sf-filter-product-item-main-image").load(function() {
        var aspect_ratio = Number(jQ(this).attr('data-aspectratio'));
        var a = jQ(this).parent();
        a.css("width", "100%").css("aspect-ratio", "1 / " + 1 / aspect_ratio);
    }).each(function() {
        this.complete && jQ(this).load()
    })
}
BCSfFilter.prototype.buildExtrasProductList = function(data, evenType) {
  if(typeof StampedFn !== 'undefined') {
  	 StampedFn.loadBadges()
  }

  if (typeof FlairApp !== 'undefined' && FlairApp) { FlairApp.refreshProductBadges(); }
}, BCSfFilter.prototype.buildAdditionalElements = function(a) {
    var b = this,
        c = a.total_product + "<span> " + bcSfFilterConfig.label.items_with_count_other + "</span>";
    1 == a.total_product && (c = a.total_product + "<span> " + bcSfFilterConfig.label.items_with_count_one + "</span>"), jQ("#bc-sf-filter-total-product").html(c), matchHeightImage(), jQ(window).resize(function() {
        matchHeightImage()
    })

    if (typeof bcUpdateLazyLoad !== 'undefined') {
      var lazy = new bcUpdateLazyLoad.default({
        elements_selector: '.lazyload'
      });
      lazy.update();
    }


  jQ(".bc-sf-filter-product-bottom ul li span").on("click", function(){
      var variantSelectedImage = jQ(this).attr("data-image");
      if (variantSelectedImage && variantSelectedImage !== 'null') {
        jQ(this).closest(".bc-sf-filter-product-item-inner").find(".bc-sf-filter-product-item-image-link img").attr("src",variantSelectedImage).attr("srcset",variantSelectedImage).attr("data-src",variantSelectedImage).attr("data-srcset",variantSelectedImage);
      }
  });
};

function buildDefaultLink(d, a) {
    var b = window.location.href.split("?")[0];
    return b += "?" + d + "=" + a
}
BCSfFilter.prototype.buildDefaultElements = function() {
    /* WS v16: same mobileStyle force as buildFilterSorting above, in case
       this legacy toolbar path is the one actually active on a given
       template — see the comment there for the full explanation. */
    this.mobileStyle = "style2";
    if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && 0 < jQ("#bc-sf-filter-bottom-pagination").length) {
        var a = bcSfFilterConfig.general.collection_count,
            b = parseInt(this.queryParams.page),
            c = Math.ceil(a / this.queryParams.limit);
        if (1 == c) return jQ(this.selector.pagination).html(""), !1;
        if ("default" == this.getSettingValue("general.paginationType")) {
            var d = bcSfFilterTemplate.paginateHtml,
                t = "";
            t = 1 < b ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", t = t.replace(/{{itemUrl}}/g, buildDefaultLink("page", b - 1)), d = d.replace(/{{previous}}/g, t);
            var u = "";
            u = b < c ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", u = u.replace(/{{itemUrl}}/g, buildDefaultLink("page", b + 1)), d = d.replace(/{{next}}/g, u);
            for (var v = [], h = b - 1; h > b - 3 && 0 < h; h--) v.unshift(h);
            0 < b - 4 && v.unshift("..."), 0 <= b - 4 && v.unshift(1), v.push(b);
            for (var w = [], j = b + 1; j < b + 3 && j <= c; j++) w.push(j);
            b + 3 < c && w.push("..."), b + 3 <= c && w.push(c);
            for (var x = "", y = v.concat(w), m = 0; m < y.length; m++) x += "..." == y[m] ? bcSfFilterTemplate.pageItemRemainHtml : y[m] == b ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, x = x.replace(/{{itemTitle}}/g, y[m]), x = x.replace(/{{itemUrl}}/g, buildDefaultLink("page", y[m]));
            d = d.replace(/{{pageItems}}/g, x), jQ(this.selector.pagination).html(d)
        }
    }
    if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && 0 < jQ(this.selector.topSorting).length) {
        jQ(this.selector.topSorting).html("");
        var z = applyWsSortingLabels(this.getSortingList());
        if (z) {
            var o = "";
            for (var A in z) o += "<option value=\"" + A + "\">" + z[A] + "</option>";
            var q = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, o);
            jQ(this.selector.topSorting).html(q);
            var r = void 0 === this.queryParams.sort_by ? this.defaultSorting : this.queryParams.sort_by;
            jQ(this.selector.topSorting + " select").val(r), jQ(this.selector.topSorting + " select").change(function() {
                window.location.href = buildDefaultLink("sort_by", jQ(this).val())
            })
        }
    }
}, BCSfFilter.prototype.prepareProductData = function(a) {
    for (var b = 0; b < a.length; b++) {
        a[b].images = a[b].images_info, a[b].featured_image = 0 < a[b].images.length ? a[b].images[0] : {
            src: bcSfFilterConfig.general.no_image_url,
            width: "",
            height: "",
            aspect_ratio: 0
        }, a[b].url = "/products/" + a[b].handle;
        for (var c = [], d = 0; d < a[b].options_with_values.length; d++) c.push(a[b].options_with_values[d].name);
        a[b].options = c, a[b].price_min *= 100, a[b].price_max *= 100, a[b].compare_at_price_min *= 100, a[b].compare_at_price_max *= 100, a[b].price = a[b].price_min, a[b].compare_at_price = a[b].compare_at_price_min, a[b].price_varies = a[b].price_min != a[b].price_max;
        var e = a[b].variants[0];
        if (null !== getParam("variant") && "" != getParam("variant")) {
            var f = a.variants.filter(function(a) {
                return a.id == getParam("variant")
            });
            "undefined" != typeof f[0] && (e = f[0])
        } else
            for (var d = 0; d < a[b].variants.length; d++)
                if (a[b].variants[d].available) {
                    e = a[b].variants[d];
                    break
                } a[b].selected_or_first_available_variant = e;
        for (var d = 0; d < a[b].variants.length; d++) {
            var g = [],
                h = a[b].variants[d],
                l = h.merged_options;
            if (Array.isArray(l)) {
                for (var m, n = 0; n < l.length; n++) m = l[n].split(":"), a[b].variants[d]["option" + (parseInt(n) + 1)] = m[1], a[b].variants[d]["option_" + m[0]] = m[1], g.push(m[1]);
                a[b].variants[d].options = g
            }
            a[b].variants[d].compare_at_price = 100 * parseFloat(a[b].variants[d].compare_at_price), a[b].variants[d].price = 100 * parseFloat(a[b].variants[d].price)
        }
        a[b].description = a[b].content = a[b].body_html
    }
    return a
};


/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

